module.exports = __webpack_public_path__ + "static/img/banner02.0de55e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner02.jpg
// module id = USPr
// module chunks = 1